'use strict';

var ProfileLevelStrategyProviderService = function ProfileLevelStrategyProviderService() {
  var strategiesMap = {};
  var strategies = Array.prototype.slice.call(arguments, 0);
  function registerStrategies(strategies) {
    for (var s = 0, l = strategies.length; s < l; s++) {
      strategiesMap[strategies[s].getProfileLevel()] = strategies[s];
    }
  }
  registerStrategies(strategies);
  function getStrategy(profileLevel) {
    var strategy = strategiesMap[profileLevel];
    if (strategy === undefined) {
      throw new Error('Invalid profile level ' + profileLevel);
    }
    return strategy;
  }
  return {
    getStrategy: getStrategy
  };
};
ProfileLevelStrategyProviderService.$inject = ['StrategyMqSpos', 'StrategyMqSposDowGrp', 'StrategyMqSposSeason', 'StrategyMqSposSeasonDowGrp'];
module.exports = ProfileLevelStrategyProviderService;